import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductDetailModule } from '@features/product-detail/product-detail.module';
import { UmbracoBlockListModule } from '@features/umbraco-block-list/umbraco-block-list.module';
import { ProductDetailPage } from '@models/umbraco.model';

@Component({
    imports: [UmbracoBlockListModule, ProductDetailModule],
    selector: 'app-product-detail-page',
    template: `
        <app-product-overview [data]="data"></app-product-overview>
        <app-umbraco-block-list [spots]="data?.spots" [theme]="data?.themeColor"></app-umbraco-block-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailPageComponent {
    @Input()
    public data?: ProductDetailPage;
}
